If Conditions are not met:
<mat-slide-toggle
  [disabled]="disabled ?? false"
  color="warn"
  class="small ml-2"
  (change)="change()"
  [(ngModel)]="value"
  >{{ value ? "Disable" : "Hide" }}</mat-slide-toggle
><br />
<span class="small gray mb-2">Default: <b>Hide</b></span>
